module.exports = __webpack_public_path__ + "static/media/converter.7e96c5e4.mp4";